import { useUnderwayStore } from './useUnderwayStore';
import { UnderwayItem } from './UnderwayItem';

/**
 * Body-only list of automation underway rows, with no chrome of its own —
 * no group header, no collapse. Rendered inside the shared bulk activities
 * popup alongside the bulk-operation groups. The host owns the scroll
 * container; this renders only the rows. Returns `null` when empty.
 */
export const AutomationUnderwaySection = () => {
  const activities = useUnderwayStore((s) => s.activities);

  if (activities.length === 0) return null;

  return (
    <>
      {activities.map((a) => (
        <UnderwayItem key={a.id} activity={a} />
      ))}
    </>
  );
};
